export default "__VITE_ASSET__5ef891ba__"